var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLink = function SvgLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0V0C43.464 0 56 12.536 56 28V28C56 43.464 43.464 56 28 56V56C12.536 56 0 43.464 0 28V28Z",
    fill: "#2A5ADA",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L24.5079 11.0046L14.9921 16.4954L11.5 18.5V37.5L14.9921 39.5046L24.5952 44.9954L28.0873 47L31.5794 44.9954L41.0079 39.5046L44.5 37.5V18.5L41.0079 16.4954L31.4921 11.0046L28 9ZM18.4841 33.4908V22.5092L28 17.0183L37.5159 22.5092V33.4908L28 38.9817L18.4841 33.4908Z",
    fill: "#2A5ADA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55.5C12.8122 55.5 0.5 43.1878 0.5 28H-0.5C-0.5 43.7401 12.2599 56.5 28 56.5V55.5ZM55.5 28C55.5 43.1878 43.1878 55.5 28 55.5V56.5C43.7401 56.5 56.5 43.7401 56.5 28H55.5ZM28 0.5C43.1878 0.5 55.5 12.8122 55.5 28H56.5C56.5 12.2599 43.7401 -0.5 28 -0.5V0.5ZM28 -0.5C12.2599 -0.5 -0.5 12.2599 -0.5 28H0.5C0.5 12.8122 12.8122 0.5 28 0.5V-0.5Z",
    fill: "#080808",
    fillOpacity: 0.08
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "LINK.c5fa0561d9ec52dbc6a3a32bd7c78633.svg";